module.exports = __webpack_public_path__ + "static/media/green.26e0bf91.svg";